import React from 'react';
import css from './ModelLinksSection.module.css';

const MODEL_LINKS = [
  { slug: 'porsche-993', label: 'Porsche 993', sub: 'Last air-cooled 911 · 1994–1998' },
  { slug: 'porsche-911-gt3', label: 'Porsche 911 GT3', sub: 'Road-legal race car · all generations' },
  { slug: 'porsche-964', label: 'Porsche 964', sub: 'Air-cooled classic · 1989–1994' },
  { slug: 'porsche-996', label: 'Porsche 996', sub: 'First water-cooled · 1997–2004' },
  { slug: 'porsche-997', label: 'Porsche 997', sub: 'Modern classic · 2005–2012' },
  { slug: 'porsche-930', label: 'Porsche 930 Turbo', sub: 'Original Turbo · 1975–1989' },
];

const ModelLinksSection = () => {
  return (
    <section className={css.section}>
      <div className={css.inner}>
        <div className={css.header}>
          <h2 className={css.heading}>Browse by Model</h2>
          <a href="/s" className={css.allLink}>View all listings →</a>
        </div>
        <div className={css.grid}>
          {MODEL_LINKS.map(({ slug, label, sub }) => (
            <a key={slug} href={`/cars/${slug}`} className={css.card}>
              <div className={css.cardBody}>
                <span className={css.cardLabel}>{label}</span>
                <span className={css.cardSub}>{sub}</span>
              </div>
              <span className={css.arrow}>→</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ModelLinksSection;
